module.exports = __webpack_public_path__ + "static/media/tds3.d4257228.png";